import axios from 'axios';

export const logout = (startProgress, stopProgress) => async () => {
  startProgress();
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'HttpRequest',
      'Csrf-Token': 'nocheck'
    },
    responseType: 'json',
    timeout: 0
  };
  const form = new FormData();
  await axios.post('/logout', form, config)
    .then((_) => {
      stopProgress();
      location.reload();
    })
    .catch((error) => {
      stopProgress();
      console.log(error);
    });
}
